
import { useAuth } from '@/hooks/useAuth'
import React, { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAuth?: boolean
  requireProvider?: boolean
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  requireProvider = false
}) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  const Skeleton = useMemo(() => (
    <div className="space-y-6 animate-pulse" role="status" aria-live="polite">
      <div className="h-8 w-48 bg-slate-200 rounded-lg" />
      <div className="grid gap-4 md:grid-cols-2">
        <div className="h-40 bg-white/70 rounded-2xl shadow-inner" />
        <div className="h-40 bg-white/70 rounded-2xl shadow-inner" />
      </div>
      <div className="h-64 bg-white/70 rounded-3xl shadow-inner" />
    </div>
  ), [])

  // Mostrar loading enquanto verifica autenticação
  if (loading) {
    return <>{Skeleton}</>
  }

  // Verificar se precisa de autenticação
  if (requireAuth && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Verificar se precisa ser prestador
  if (requireProvider && user) {
    // Aqui você pode adicionar lógica para verificar se o usuário é prestador
    // Por enquanto, vamos assumir que qualquer usuário autenticado pode acessar
    return <>{children}</>
  }

  return <>{children}</>
}
